<app-header></app-header>
<app-info-bar></app-info-bar>
<app-create-pizza></app-create-pizza>
<app-delivery-map></app-delivery-map>